import { z } from 'zod';
import { RoutingRuleBillAggregationType } from '@mews-commander/data-access';
import { RoutingRulesFormStepName } from '../types';

export enum TargetBillFormFields {
    TargetType = 'targetType',
    AggregationType = 'aggregationType',
    IncludeCompanyDetails = 'includeCompanyDetails',
    GuestProfileTarget = 'guestProfileTarget',
}

export enum TargetBillType {
    CompanyBill = 'companyBill',
    GuestBill = 'guestBill',
}

export const targetBillSchema = z.object({
    [RoutingRulesFormStepName.TargetBill]: z.object({
        [TargetBillFormFields.TargetType]: z.nativeEnum(TargetBillType),
        [TargetBillFormFields.AggregationType]: z.nativeEnum(RoutingRuleBillAggregationType).optional(),
        [TargetBillFormFields.IncludeCompanyDetails]: z.array(z.string()),
        [TargetBillFormFields.GuestProfileTarget]: z.string().optional().nullable(),
    }),
});

export type targetBillSchemaFormValues = z.infer<typeof targetBillSchema>;
